import { render, staticRenderFns } from "./CopyQuestionFromProjects.vue?vue&type=template&id=565e47e0&scoped=true"
import script from "./CopyQuestionFromProjects.vue?vue&type=script&lang=js"
export * from "./CopyQuestionFromProjects.vue?vue&type=script&lang=js"
import style0 from "./CopyQuestionFromProjects.vue?vue&type=style&index=0&id=565e47e0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e47e0",
  null
  
)

export default component.exports